//GenerateGiftCouponCode.js
import React from 'react';

const generateGiftCouponCode = () => {
    const currentDate = new Date();
    const year = getYearCode(currentDate.getFullYear());
    const month = getMonthCode(currentDate.getMonth() + 1);
    const day = getDayCode(currentDate.getDate());
    const hours = getHourCode(currentDate.getHours());
    const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}0`;
};

const getYearCode = (year) => {
    const lastTwoDigits = year.toString().slice(-2);
    return lastTwoDigits;
};

const getMonthCode = (month) => {
    if (month >= 1 && month <= 9) {
        return month.toString();
    } else {
        return String.fromCharCode(64 + month - 9); // A = 10, B = 11, ...
    }
};

const getDayCode = (day) => {
    if (day >= 1 && day <= 9) {
        return day.toString();
    } else {
        return String.fromCharCode(64 + day - 9); // A = 10, B = 11, ...
    }
};

const getHourCode = (hour) => {
    if (hour >= 1 && hour <= 9) {
        return hour.toString();
    } else {
        return String.fromCharCode(64 + hour - 9); // A = 10, B = 11, ...
    }
};

const reverseGiftCouponCode = (couponCode) => {
    const year = couponCode.slice(0, 2);
    const month = getMonthFromCode(couponCode.slice(2, 3)); 
    const day = getDayFromCode(couponCode.slice(3, 4)); 
    const hours = getHourFromCode(couponCode.slice(4, 5)); 
    const minutes = couponCode.slice(5, 7);
    const seconds = couponCode.slice(7, 9);
    const milliseconds = couponCode.slice(9, 12);
    const dateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
    return dateString;
    
};

// Helper functions to convert code back to numeric values
const getMonthFromCode = (code) => {
    if (code >= 'A' && code <= 'L') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

const getDayFromCode = (code) => {
    if (code >= 'A' && code <= 'Z') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

const getHourFromCode = (code) => {
    if (code >= 'A' && code <= 'Z') {
        return code.charCodeAt(0) - 64 + 9; 
    } else {
        return code;
    }
};

export { generateGiftCouponCode, reverseGiftCouponCode };